<template>
  <a-row :gutter="16">
    <a-col :span="12">
      <div style="height:30px">
        服务预算
      </div>
      <a-input
        type="number"
        :disabled="disabled"
        addon-after="元"
        placeholder="请输入服务预算"
        :value="budget"
        @change="handleChange"
      />
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: ['value', 'disabled'],
  data() {
    const value = this.value || {};
    return {
      budget: value.budget,
    };
  },
  watch: {
    value(val = {}) {
      this.budget = val.budget;
    },
  },
  methods: {
    handleChange(e) {
      this.$emit(
        'change',
        Object.assign({}, this.$data, { budget: e.target.value }),
      );
    },
  },
};
</script>
